import React, { useState } from 'react';
import { mediaGallery } from '../mockData';

const Media = () => {
  const [selectedMedia, setSelectedMedia] = useState(null);

  return (
    <div className="page-container media-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="page-hero-bg" 
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1759127481171-30a27de310ad?w=1920)' }}
        >
          <div className="page-hero-overlay" />
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Media Gallery</h1>
          <p className="page-hero-subtitle">
            Moments of worship, fellowship, and community captured
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="content-section">
        <div className="container">
          <div className="media-gallery">
            {mediaGallery.map(media => (
              <div 
                key={media.id} 
                className="media-item"
                onClick={() => setSelectedMedia(media)}
              >
                <img src={media.thumbnail} alt={media.title} />
                <div className="media-overlay">
                  <h4>{media.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {selectedMedia && (
        <div className="media-lightbox" onClick={() => setSelectedMedia(null)}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={() => setSelectedMedia(null)}>
              ×
            </button>
            <img src={selectedMedia.url} alt={selectedMedia.title} />
            <h3>{selectedMedia.title}</h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default Media;
